import { convertSnakeToCamel } from "@/app/infrastructures/misc/common-library/ConvertSnakeToCamel";
import { PosLeaderboard, PosLeaderboardCofig, Tier } from "@/domain/entities/PosLeaderboard";
import { Cursor, HistoryRank, Leaderboard, Meta, PosLeaderboardList } from "@/domain/entities/PosLeaderboard";
import { AxiosResponse } from "axios";

export class POSLeaderboardMapper {
  convertPOSLeaderboardListFromApi(res: any) {
    const { data: { data: {meta, leaderboard} } } = res;

    const leaderboardList = Array.isArray(leaderboard) ? leaderboard : [];

    return new PosLeaderboardList({
      meta: new Meta({
        cursor: new Cursor({
          next: meta.cursor?.next,
          previous: meta.cursor?.previous
        }),
        lastSyncAt: meta.last_sync_at,
        mode: meta.mode,
        period: meta.period,
        scope: meta.scope
      }),
      leaderboard: leaderboardList.map((ldb: any) => {
        const historyRank = Array.isArray(ldb.history_rank) ? ldb.history_rank : [];

        return new Leaderboard({
          rank: ldb.rank,
          rankDelta: ldb.rank_delta,
          name: ldb.name,
          posCode: ldb.pos_code,
          cityCode: ldb.city_code,
          revenue: ldb.revenue,
          reward: ldb.reward,
          tier: ldb.tier,
          isCurrentPos: ldb.is_current_pos,
          historyRank: historyRank.sort((a: any,b: any) => a.rank-b.rank).map((hr: any) => {
            return new HistoryRank({
              rank: hr.rank,
              count: hr.count
            });
          })
        })
      })
    });
  }

  convertSummaryFromApi(res: AxiosResponse<any>): PosLeaderboard {
    const {
      data: { data }
    } = res;

    return !Object.keys(data?.cards).length
      ? new PosLeaderboard({ isNoData: true })
      : new PosLeaderboard(convertSnakeToCamel(data));
  }

  convertConfigFromApi(res: AxiosResponse<any>) {
    const {
      data: { data: { data } }
    } = res;

    const configs = Array.isArray(data) ? data : [];

    return configs.map((config: any) => {
      const tiers = Array.isArray(config.tier) ? config.tier : [];

      return new PosLeaderboardCofig({
        scope: config.scope,
        areaCode: config.area_code,
        tier: tiers.map((tier: any) => {
          return new Tier({
            areaCode: tier.area_code,
            configId: tier.config_id,
            rewardTier: tier.reward_tier,
            rankEnd: tier.rank_end,
            rankStart: tier.rank_start
          });
        })
      });
    })
  }

}
